// 商品信息模块
const productInfo = [
  {
    path: "/product/category",
    name: "category",
    meta: {
      title: "产品分类-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/product/Category"),
  },
  {
    path: "/product/details",
    name: "details",
    meta: {
      title: "产品详情-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/product/Details"),
  },
  {
    path: "/product/offer",
    name: "offer",
    meta: {
      title: "报价列表-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/product/Offer"),
  },
];

export default productInfo;
